import { axiosClient, axiosSSOConfigPrivate } from '../../api';
import { API_BASE_MAILING_URL } from '../urls';

export const fetchTemplates = async (start = 0, limit = 1000, platform = null) => {
  let url = `${API_BASE_MAILING_URL}/admin/templates?start=${start}&limit=${limit}`;
  if (platform) {
    url += `&platform=${platform}`;
  }
  return axiosClient.get(url, axiosSSOConfigPrivate());
};

export const fetchTemplate = async (id) =>
  axiosClient.get(`${API_BASE_MAILING_URL}/admin/templates/load?id=${id}`, axiosSSOConfigPrivate());

export const saveTemplate = async (data) =>
  axiosClient.post(`${API_BASE_MAILING_URL}/admin/templates/save`, data, axiosSSOConfigPrivate());

export const updateTemplate = async (id, data) =>
  axiosClient.post(
    `${API_BASE_MAILING_URL}/admin/templates/save`,
    { id, ...data },
    axiosSSOConfigPrivate()
  );

export const deleteTemplate = async (id) =>
  axiosClient.get(
    `${API_BASE_MAILING_URL}/admin/templates/delete?id=${id}`,
    axiosSSOConfigPrivate()
  );

export const previewTemplate = async (id) =>
  axiosClient.get(
    `${API_BASE_MAILING_URL}/admin/templates/preview?id=${id}`,
    axiosSSOConfigPrivate()
  );

export const sendTemplateApi = async (data) =>
  axiosClient.post(
    `${API_BASE_MAILING_URL}/mail`,
    data,
    axiosSSOConfigPrivate({ 'Content-Type': 'multipart/form-data' })
  );

export const getTemplateFileUploadLink = (name) =>
  axiosClient.get(
    `${API_BASE_MAILING_URL}/media/public-upload?name=${name}&path=email`,
    axiosSSOConfigPrivate()
  );

export const getTemplatesSettings = () =>
  axiosClient.get(`${API_BASE_MAILING_URL}/admin/settings`, axiosSSOConfigPrivate());

export const saveTemplatesSettings = (data) =>
  axiosClient.post(`${API_BASE_MAILING_URL}/admin/settings/save`, data, axiosSSOConfigPrivate());

export const deleteTemplatesSettings = (key) =>
  axiosClient.get(
    `${API_BASE_MAILING_URL}/admin/settings/delete?key=${key}`,
    axiosSSOConfigPrivate()
  );

export const getSettingsCategories = () =>
  axiosClient.get(`${API_BASE_MAILING_URL}/admin/settings/categories`, axiosSSOConfigPrivate());
